function Header() {
  return (
    <>
      <header className="header-nav-container">
        <div id="header" className="header-lcc">
          <section className="sectionHeader">
						<div className="container-fluid">
							<div className="header-wrapper">
								<div className="header-logo">
									<a title="Go to the homepage" href="/">More online forms<span className="sr-only"> Go to home page</span></a>
								</div>
							</div>
            </div>
          </section>
        </div>
      </header>
    </>
  );
}
export default Header;
